import { useState, useEffect, useCallback } from 'react';

const isBrowser = typeof window !== 'undefined';

// Returns a reactive version of the current time
const useTime = (timeZone = 'America/New_York', refreshCycle = 30000) => {
  const getTime = useCallback(
    () =>
      new Date().toLocaleTimeString('en-US', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        seconds: false
      }),
    [timeZone]
  );

  const [now, setNow] = useState('00:00 AM');

  // Set time in initial render
  useEffect(() => {
    if (!isBrowser) return;

    setNow(getTime());
  }, []);

  useEffect(() => {
    if (!isBrowser) return;

    // Regularly set time in state
    // (this will cause your component to re-render frequently)
    const intervalId = setInterval(() => setNow(getTime()), refreshCycle);

    // Cleanup interval
    return () => clearInterval(intervalId);

    // Specify dependencies for useEffect
  }, [refreshCycle, now, getTime]);

  return now;
};

export default useTime;
